import {useMutation} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {uploadBarcodeExcel} from "../../../../api/inventory/BarcodeApi";
import {useModal} from "../../../../hooks";

export const useUploadBarcodeExcel = () => {
    const {handleModal} = useModal();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: FormData) => uploadBarcodeExcel(data),
        onSuccess: () => {
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
